(function () {
  var STORAGE_KEY = 'rb_wishlist';

  var CARD_IMAGE_SELECTORS =
    '.rb-card-image, .rb-prom-image, .rb-gown-image, .card__media, .product-card__media';

  var HEART_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>' +
    '</svg>';

  function getAll() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function save(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    document.dispatchEvent(new CustomEvent('rb:wishlist:change', { detail: { handles: handles } }));
  }

  function has(handle) {
    return getAll().indexOf(handle) !== -1;
  }

  function add(handle) {
    if (!handle || has(handle)) return getAll();
    var list = getAll();
    list.push(handle);
    save(list);
    return list;
  }

  function remove(handle) {
    var list = getAll().filter(function (h) {
      return h !== handle;
    });
    save(list);
    return list;
  }

  function toggle(handle) {
    if (!handle) return getAll();
    return has(handle) ? remove(handle) : add(handle);
  }

  function escapeHtml(str) {
    var el = document.createElement('div');
    el.textContent = str || '';
    return el.innerHTML;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    if (window.rbMoneyFormat) {
      return window.rbMoneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString())
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    return amount;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (response) {
      if (!response.ok) throw new Error('Product not found');
      return response.json();
    });
  }

  function extractHandleFromPath(path) {
    var match = (path || '').match(/\/products\/([^/?#]+)/);
    if (!match) return null;

    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  function createButton(handle, style) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = style === 'product' ? 'rb-wish-btn' : 'rb-wishlist-btn';
    btn.setAttribute('data-wishlist-handle', handle);
    btn.setAttribute('data-wishlist-auto', 'true');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = HEART_SVG;
    return btn;
  }

  function findImageWrapper(scope) {
    if (!scope) return null;
    var selectors = CARD_IMAGE_SELECTORS.split(',');
    var i;

    for (i = 0; i < selectors.length; i += 1) {
      var wrapper = scope.querySelector(selectors[i].trim());
      if (wrapper) return wrapper;
    }

    var img = scope.querySelector('img');
    if (img && img.parentElement && img.parentElement !== scope) {
      return img.parentElement;
    }

    return null;
  }

  /* Any element that is, or contains, a link to a product page. */
  function findProductLink(card) {
    if (card.tagName === 'A' && /\/products\//.test(card.getAttribute('href') || '')) {
      return card;
    }
    return card.querySelector('a[href*="/products/"]');
  }

  /* Resolve a product handle for a card from its data attribute or its
     product link href — so no per-section markup is required. */
  function resolveHandle(card) {
    var handle = card.getAttribute('data-product-handle');
    if (handle) return handle;

    var link = findProductLink(card);
    if (link) return extractHandleFromPath(link.getAttribute('href'));

    return null;
  }

  /* Card containers used across every Robéne / Dawn product grid. We match by
     container, then keep only those that actually resolve to a product. */
  var CARD_SELECTORS = [
    '.rb-card',
    '.rb-prom-card',
    '.rb-gown-card',
    '.card-wrapper',
    '.product-card'
  ];

  function mountButton(card, handle) {
    // Already wired by a previous pass.
    if (card.querySelector('[data-wishlist-handle]')) return;

    // Wire an existing (inert) heart button if the section ships one.
    var existing = card.querySelector('.rb-wishlist-btn, .rb-wish-btn');
    if (existing) {
      existing.setAttribute('data-wishlist-handle', handle);
      existing.setAttribute('data-wishlist-auto', 'true');
      existing.setAttribute('aria-pressed', 'false');
      if (!existing.getAttribute('aria-label')) {
        existing.setAttribute('aria-label', 'Add to wishlist');
      }
      if (!existing.innerHTML.trim()) existing.innerHTML = HEART_SVG;
      return;
    }

    // Otherwise inject a fresh button into the card's image area.
    var mount = findImageWrapper(card) || card;
    if (window.getComputedStyle(mount).position === 'static') {
      mount.style.position = 'relative';
    }
    mount.appendChild(createButton(handle, 'card'));
  }

  function injectCardButtons(root) {
    root = root || document;
    var cards = root.querySelectorAll(CARD_SELECTORS.join(','));

    cards.forEach(function (card) {
      if (card.closest('[data-rb-no-wishlist]')) return;

      var handle = resolveHandle(card);
      if (!handle) return; // not a product card

      mountButton(card, handle);
    });
  }

  function injectProductPageButton() {
    var actions = document.querySelector('.rb-actions[data-product-handle]');
    var handle;

    if (actions) {
      handle = actions.getAttribute('data-product-handle');
    } else if (/\/products\/[^/?#]+/.test(window.location.pathname)) {
      actions = document.querySelector('.rb-actions');
      handle = extractHandleFromPath(window.location.pathname);
    }

    if (!actions || !handle) return;
    if (actions.querySelector('[data-wishlist-handle]')) return;

    actions.appendChild(createButton(handle, 'product'));
  }

  function injectAll(root) {
    injectCardButtons(root);
    injectProductPageButton();
    syncButtons();
  }

  function syncButtons() {
    var handles = getAll();
    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var active = handles.indexOf(handle) !== -1;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function updateHeaderCount() {
    var count = getAll().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (count > 0) {
        el.textContent = count > 9 ? '9+' : String(count);
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  }

  function bindToggleButtons() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wishlist-handle]');
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      toggle(btn.getAttribute('data-wishlist-handle'));
    }, true);
  }

  function observeDynamicContent() {
    if (!window.MutationObserver || !document.body) return;

    var scheduled = false;

    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        injectAll();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function renderWishlistPage() {
    var page = document.getElementById('rbWishlistPage');
    if (!page) return;

    var grid = document.getElementById('rbWishlistGrid');
    var empty = document.getElementById('rbWishlistEmpty');
    var loading = document.getElementById('rbWishlistLoading');
    var countEl = document.getElementById('rbWishlistCount');

    function showState(state) {
      if (loading) loading.hidden = state !== 'loading';
      if (empty) empty.hidden = state !== 'empty';
      if (grid) grid.hidden = state !== 'grid';
    }

    function render() {
      var handles = getAll();

      if (countEl) {
        if (handles.length) {
          countEl.textContent = handles.length + ' saved piece' + (handles.length === 1 ? '' : 's');
          countEl.hidden = false;
        } else {
          countEl.textContent = '';
          countEl.hidden = true;
        }
      }

      if (!handles.length) {
        if (grid) grid.innerHTML = '';
        showState('empty');
        return;
      }

      showState('loading');

      Promise.all(
        handles.map(function (handle) {
          return fetchProduct(handle).catch(function () {
            return null;
          });
        })
      ).then(function (products) {
        products.forEach(function (product, index) {
          if (!product) remove(handles[index]);
        });

        var validProducts = products.filter(Boolean);

        if (!validProducts.length) {
          if (grid) grid.innerHTML = '';
          showState('empty');
          return;
        }

        if (grid) {
          grid.innerHTML = validProducts
            .map(function (product) {
              var image = product.featured_image || (product.images && product.images[0]) || '';
              var category = product.type || 'Collection';

              return (
                '<article class="rb-wl-card">' +
                  '<div class="rb-wl-card-image">' +
                    '<a href="' + product.url + '" class="rb-wl-card-link">' +
                      '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
                    '</a>' +
                    '<button type="button" class="rb-wl-remove" data-wishlist-handle="' + escapeHtml(product.handle) + '" aria-label="Remove from wishlist">' +
                      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
                        '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>' +
                      '</svg>' +
                    '</button>' +
                  '</div>' +
                  '<div class="rb-wl-card-content">' +
                    '<p class="rb-wl-category">' + escapeHtml(category) + '</p>' +
                    '<a href="' + product.url + '" class="rb-wl-title">' + escapeHtml(product.title) + '</a>' +
                    '<p class="rb-wl-price">' + formatMoney(product.price) + '</p>' +
                    '<a href="' + product.url + '" class="rb-wl-shop-btn">View piece</a>' +
                  '</div>' +
                '</article>'
              );
            })
            .join('');
        }

        showState('grid');
        syncButtons();
      });
    }

    document.addEventListener('rb:wishlist:change', render);
    render();
  }

  function init() {
    bindToggleButtons();
    injectAll();
    updateHeaderCount();
    renderWishlistPage();
    observeDynamicContent();

    document.addEventListener('rb:wishlist:change', function () {
      syncButtons();
      updateHeaderCount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    injectAll();
    updateHeaderCount();
  });

  window.RbWishlist = {
    getAll: getAll,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    injectAll: injectAll,
    syncButtons: syncButtons,
    updateHeaderCount: updateHeaderCount
  };
})();
